<template>
  <p>
    Uuuuupsi: Das hätte nicht passieren dürfen. Anscheinend haben Sie einen veralteten Link gefunden. Nutzen Sie die Navigation oben, um zurück zur Hauptseite zu gelangen.
  </p>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style scoped>
p {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    color: #f10b0b;
}
</style>